import { getInvitationData } from '@fiverr-private/pro_migration';
import { logError } from '../utils/logError';

export type InvitationData = Awaited<ReturnType<typeof getInvitationData>>['invitationData'];

export const checkEmailInvitation = async (email: string, source: string) => {
    try {
        if (!email) {
            throw new Error('Email should be defined');
        }

        const { invitationData } = await getInvitationData({ email, source });

        return invitationData ? invitationData : null;
    } catch (error) {
        logError({
            message: 'Error checkEmailInvitation',
            error,
        });
        throw error;
    }
};
